import { useFind } from 'api/APIHooks';

export const useFindMostRecentInvoice = (providedServiceId) => {
  const { data: invoiceApiData, isLoading } = useFind(
    'invoice',
    {
      provided_service: providedServiceId,
      state: 'active',
    },
    {
      page: {
        number: 1,
        size: 1,
      },
      sort: '-created_at',
      queryConfig: {
        enabled: !!providedServiceId,
        placeholderData: undefined,
      },
    },
  );
  const invoicesData = invoiceApiData?.data?.data ?? [];
  const mostRecentInvoice = invoicesData[0];

  return {
    invoice: mostRecentInvoice,
    isLoading,
  };
};
